import { _ as s } from "./index.es97.js";
import { l as t } from "./index.es272.js";
import { _ as e } from "./index.es273.js";
import { _ } from "./index.es274.js";
var m = s, n = t, o = e, l = _;
function f(r, a) {
  return a = m(a, r), r = o(r, a), r == null || delete r[l(n(a))];
}
var y = f;
export {
  y as _
};
//# sourceMappingURL=index.es96.js.map
